module.exports = __webpack_public_path__ + "img/gb9113_15_a.prt.2e543986.jpg";